/**
 * LH Variant Image Switcher
 * Variant image URL ko slideshow ki img src se match karke
 * sahi slide pe jump karta hai.
 */
(function () {
  'use strict';

  // Liquid se embed ki gayi variant->imageUrl map padhna
  function getVariantImageMap(card) {
    var el = card.querySelector('[data-lh-variant-media]');
    if (!el) return {};
    try { return JSON.parse(el.textContent.trim()) || {}; }
    catch (e) { return {}; }
  }

  // Image URL ka base filename nikaalna (params hatake)
  function getBaseName(url) {
    if (!url) return '';
    var clean = url.split('?')[0];
    return clean.split('/').pop();
  }

  function goToImageInCard(card, imageUrl) {
    if (!imageUrl) return;
    var targetBase = getBaseName(imageUrl);
    if (!targetBase) return;

    var slideshow = card.querySelector('slideshow-container');
    if (!slideshow) return;

    // Har slide ki img src se match karo
    var slides = Array.from(slideshow.querySelectorAll('[data-media-id]'));
    if (!slides.length) return;

    var targetIndex = -1;
    slides.forEach(function(slide, i) {
      if (targetIndex >= 0) return;
      var imgs = slide.querySelectorAll('img');
      imgs.forEach(function(img) {
        if (targetIndex >= 0) return;
        var srcBase = getBaseName(img.src || img.getAttribute('src') || '');
        var srcsetBase = '';
        var srcset = img.srcset || img.getAttribute('srcset') || '';
        if (srcset) {
          // srcset ki pehli entry ka filename
          srcsetBase = getBaseName(srcset.split(',')[0].trim().split(' ')[0]);
        }
        if (srcBase === targetBase || srcsetBase === targetBase) {
          targetIndex = i;
        }
      });
    });

    if (targetIndex < 0) {
      // Fallback: data-media-id se exact match try karo
      var mediaId = card.querySelector('[data-lh-variant-media]');
      return;
    }

    // Slideshow jump
    if (typeof slideshow.select === 'function') {
      slideshow.select(targetIndex);
      return;
    }
    slideshow.dispatchEvent(new CustomEvent('slideshow:select', {
      detail: { index: targetIndex, userInitiated: true },
      bubbles: false
    }));

    // Fallback scroll
    try { slides[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); }
    catch(e) {}
  }

  function handleVariantChange(card, variantId) {
    var map = getVariantImageMap(card);
    var imageUrl = map[String(variantId)];
    if (imageUrl) goToImageInCard(card, imageUrl);
  }

  // Radio button change (variant buttons/swatches)
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (!target || target.tagName !== 'INPUT') return;
    var card = target.closest('product-card');
    if (!card) return;
    var variantId = target.dataset.variantId;
    if (!variantId) return;
    handleVariantChange(card, variantId);
  });

  // Horizon events bhi try karo
  document.addEventListener('variant:selected', function(e) {
    var resource = e.detail && e.detail.resource;
    if (!resource) return;
    var card = e.target ? e.target.closest('product-card') : null;
    if (!card) return;
    handleVariantChange(card, resource.id);
  });

  document.addEventListener('variant:update', function(e) {
    var resource = e.detail && e.detail.resource;
    if (!resource) return;
    var card = e.target ? e.target.closest('product-card') : null;
    if (!card) return;
    handleVariantChange(card, resource.id);
  });

})();
